import HomeHeaderContainer from './HomeHeaderContainer';
import './HomeHeader.css'

const HomeHeader = ({ isHeaderLeft = true, showLoginButton, showSignupButton }) => {
  return (
    <header className="site-header">
      <div className={isHeaderLeft ? 'header-gutters' : 'header-gutters-alternate'}>
        <HomeHeaderContainer showLoginButton={showLoginButton} showSignupButton={showSignupButton}/>
      </div>
    </header>
  );
}

export default HomeHeader;